import { render, staticRenderFns } from "./email-report.vue?vue&type=template&id=5a0a91b8&scoped=true"
import script from "./email-report.vue?vue&type=script&lang=js"
export * from "./email-report.vue?vue&type=script&lang=js"
import style0 from "./email-report.vue?vue&type=style&index=0&id=5a0a91b8&prod&lang=css"
import style1 from "./email-report.vue?vue&type=style&index=1&id=5a0a91b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0a91b8",
  null
  
)

export default component.exports